import { PaywallAuthErrorCodes, PaywallPlans, SiteLinks, SignInType } from "../../../../../global/paywall/paywallInterfaces";
import { PremiumPaywallState } from "../premiumPaywallMobile";
import { PremiumPaywallSigninEmailNewspaper } from "../../desktop/signin/premiumPaywallDesktopSigninEmail";

interface PremiumPaywallMobileSigninEmailProps {
  emailOrPhone: string
  setEmailOrPhone: (emailOrPhone: string) => void
  setMode: (state: PremiumPaywallState) => void
  loginWithGoogle: () => void
  loginWithApple: () => void
  sendMail: () => void
  authError: string
  isNewspaper?: boolean;
  setAuthError?: (error: PaywallAuthErrorCodes) => void;
  setSignInType?: (type: SignInType) => void;
  signInType?: SignInType;
}

const contactUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.contact : '';
const isSmsSignInEnabled = typeof window !== "undefined" && window.ENABLE_SIGNIN_VIA_SMS;

declare const window: Window & {
  PAYWALL_PLANS: PaywallPlans
  PAYWALL_SITE_LINKS: SiteLinks;
  ENABLE_SIGNIN_VIA_SMS: boolean;
}

const errorMessage: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.INVALID_EMAIL]: 'כתובת דוא"ל אינה תקינה',
  [PaywallAuthErrorCodes.INVALID_CELL_PHONE_NUMBER]: 'מספר טלפון אינו תקין',
  [PaywallAuthErrorCodes.FAILED_TO_SEND_OTP]: "אירעה שגיאה במערכת, אנא נסו שוב מאוחר יותר",
  [PaywallAuthErrorCodes.NOT_REGISTERED]: 'פרטי ההתחברות שהוזנו אינם נכונים',
  [PaywallAuthErrorCodes.NOT_REGISTERED_PHONE]: `פרטי ההתחברות שהוזנו אינם נכונים, ניתן לעדכן באזור האישי לאחר התחברות או לפנות ל<a href="${contactUrl}" className="contact-link">שירות הלקוחות</a>`,
  [PaywallAuthErrorCodes.OTP_MAX_ATTEMPTS]: "חרגת ממספר בקשות אימות. יש לפנות לשירות לקוחות",
  [PaywallAuthErrorCodes.NON_UNIQUE_PHONE_NUMBER]: `מספר הטלפון שייך ליותר מחשבון אחד. אנא הזדהה באמצעות כתובת דוא"ל`,
}


export const PremiumPaywallMobileSigninEmail = (props: PremiumPaywallMobileSigninEmailProps) => {

  const { emailOrPhone, setEmailOrPhone, loginWithApple, loginWithGoogle, setMode, sendMail, authError, isNewspaper, setAuthError, signInType, setSignInType } = props

  const handleMailChange = (e) => {
    setEmailOrPhone(e.target.value)
    if (e.target.value.length === 0 && authError) {
      setAuthError(null);
    }
  }
  const handleSendMail = () => {
    sendMail()
    const accountSendMailAnalytics = new CustomEvent("accountSendMailAnalytics", { detail: { label: "signin" } })
    document.dispatchEvent(accountSendMailAnalytics);
  }
  const loginEvent = (mode) => {
    setMode({ mode: mode })
    const loginButtonEvent = new CustomEvent("loginButtonEvent", { detail: { mode: mode } })
    document.dispatchEvent(loginButtonEvent);
  }
  const loginWithThirdPartyEvent = (type: string) => {
    type === "google" ? loginWithGoogle() : loginWithApple();
    const handleThirdPartyLogin = new CustomEvent("handleThirdPartyLogin", { detail: { loginMethod: type, type: "signin" } })
    document.dispatchEvent(handleThirdPartyLogin);
  }
  const handleNewspaperRegister = () => {
    setMode({ mode: 'signIn', isNewspaper: true })
    const newspaperRegisterEvent = new CustomEvent("handleNewspaperRegister")
    document.dispatchEvent(newspaperRegisterEvent);
  }
  const handleEmailReset = () => {
    setEmailOrPhone('');
    setAuthError(null);
  }

  const handleSignInType = (e) => {
    const newSignInType = e.target.value as SignInType;
    setSignInType(newSignInType);
  }

  const handlePressKey = (e) => {
    if (e.key === 'Enter') {
      handleSendMail();
    }
  }

  if (isNewspaper) {
    return <PremiumPaywallSigninEmailNewspaper {...props} handleEmailReset={handleEmailReset} handleSendMail={handleSendMail} handleMailChange={handleMailChange} isMobile contactUrl={contactUrl} />
  } else {

    return (
      <div className="premium-paywall-mobile-signin-email">
        <h1 className="title">כניסה</h1>
        {isSmsSignInEnabled && <div className="radio-buttons-container">
          <label className="radio-option">
            <input
              type="radio"
              name="signin-type"
              value={SignInType.otpEmail}
              checked={signInType === SignInType.otpEmail}
              onChange={handleSignInType}
            />
            <span className="radio-text">באמצעות דוא"ל</span>
          </label>
          <label className="radio-option">
            <input
              type="radio"
              name="signin-type"
              value={SignInType.otpPhone}
              checked={signInType === SignInType.otpPhone}
              onChange={handleSignInType}
            />
            <span className="radio-text">באמצעות מס' טלפון נייד</span>
          </label>
        </div>}
        <div className={`email-signin ${authError && authError === PaywallAuthErrorCodes.INVALID_EMAIL ? 'error' : ''}`}>
          <input
            onKeyDown={handlePressKey}
            value={emailOrPhone}
            onChange={handleMailChange}
            inputMode={signInType === SignInType.otpPhone ? "numeric" : "email"}
            placeholder={isSmsSignInEnabled ? 'הקלידו כאן...' : 'הקלידו כתובת דוא"ל'}
            type="text"
            {...(signInType === SignInType.otpPhone && {
              inputmode: "numeric",
              pattern: "[0-9]*"
            })}
          />
          {emailOrPhone && <div className="reset-icon" onClick={handleEmailReset}></div>}
          <p
            className="error-text"
            dangerouslySetInnerHTML={{ __html: errorMessage[authError] }}
          />
        </div>
        <div className="buttons-container">
          <button className="button-base continue" disabled={!emailOrPhone.length} onClick={handleSendMail}>המשך</button>
        </div>
        <div className="separator">
          <div className="line" />
          <span className="text">או באמצעות</span>
          <div className="line" />
        </div>
        <div className="social-signin">
          <button className="social-button google-btn" onClick={() => loginWithThirdPartyEvent('google')}><span>גוגל</span></button>
          <button className="social-button apple-btn" onClick={() => loginWithThirdPartyEvent('apple')}><span>אפל</span></button>
        </div>


        <div className="signup">
          <div>לא מנויים? <button type="button" onClick={() => loginEvent('signUp')}>לרכישת מינוי</button></div>
        </div>

        <div className="newspaper-users" >
          <div><span>מנויים לעיתון</span> <span className="yedioth-label"></span></div>
          <div onClick={() => handleNewspaperRegister()} className="newspaper-register-text">צרו חשבון ל-<div className="yedioth-plus-label"></div>ללא עלות</div>
        </div>
      </div>
    )
  }
}
